import React, {useEffect, useImperativeHandle, useState} from "react";
import {Button, ButtonGroup, Card, Col, Form, Row, Spinner, Table,} from "react-bootstrap";
import {Header} from "../../genericComponents";
import DinamicFilter from "./dinamic-filter/DinamicFilter";
import "./css-dinamic-filter.css";

function DataTableDinamicFilter(
  { fields, columns, ajaxData, onSelect, actions, pageTile, pageForm },
  ref
) {
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState({
    list: [],
    filters: [],
    totalRecords: 0,
    totalPages: 0,
    limit: 20,
    page: 1,
    offset: 0,
  });
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  useImperativeHandle(ref, () => ({
    refreshDataTable() {
      refresh();
    },
  }));

  useEffect(() => {
    refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // Atualiza o estado selectAll baseado nas linhas selecionadas
    if (page.list.length > 0) {
      setSelectAll(selectedRows.length === page.list.length);
    }
  }, [selectedRows, page.list]);

  function refresh(pageParams) {
    let p = { ...page };
    if (pageParams) {
      p = { ...p, ...pageParams };
    }
    p.offset = (p.page - 1) * p.limit;

    const params = {
      limit: p.limit,
      offset: p.offset,
      filters: p.filters,
    };

    setLoading(true);
    ajaxData(params)
      .then((result) => {
        p.list = result.data?.records || [];
        p.totalRecords = result.data?.totalRecords;
        p.totalPages = Math.ceil((result.data?.totalRecords || 1) / p.limit);
        setPage({ ...p });
        setLoading(false);
        // Limpar seleção ao atualizar dados
        setSelectedRows([]);
        setSelectAll(false);
      })
      .catch((e) => alert(e));
  }

  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    setSelectAll(checked);

    if (checked) {
      setSelectedRows([...page.list]);
      if (onSelect) {
        onSelect([...page.list]);
      }
    } else {
      setSelectedRows([]);
      if (onSelect) {
        onSelect([]);
      }
    }
  };

  const handleSelectRow = (row, checked) => {
    let newSelection;

    if (checked) {
      newSelection = [...selectedRows, row];
    } else {
      newSelection = selectedRows.filter(r => r !== row);
    }

    setSelectedRows(newSelection);
    if (onSelect) {
      onSelect(newSelection);
    }
  };

  const isRowSelected = (row) => {
    return selectedRows.includes(row);
  };

  const isMobile = window.innerWidth <= 991;

  return (
    <div style={{ position: "relative" }}>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255,255,255,0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <Spinner animation="border" variant="primary" />
        </div>
      )}

      <Header active={pageTile} logged />

      <div
        style={{
          height: window.innerHeight - 100 + "px",
          overflowX: "auto",
        }}
      >
        <div>
          {pageForm && (
            <Card className="dinamic-filter box-card mx-3 mt-3">
              <Card.Header>
                <div className="clearfix">Inserir/Alterar</div>
              </Card.Header>
              <Card.Body>{pageForm}</Card.Body>
            </Card>
          )}

          <DinamicFilter
            fields={fields}
            filterFn={(f) => refresh({ filters: f || [] })}
            actions={actions}
            afterClearFilterFn={() => refresh({ page: 1, filters: [] })}
          />

          <Card className="box-card mx-3 my-3">
            <Card.Body>
              <div id="ds-data-table">
                {!isMobile ? (
                  <div style={{ overflowX: "auto" }}>
                    <Table
                      striped
                      bordered
                      hover
                      responsive
                      style={{ wordBreak: "break-word" }}
                    >
                      <thead>
                      <tr>
                        <th style={{ width: "50px", textAlign: "center" }}>
                          <Form.Check
                            type="checkbox"
                            checked={selectAll}
                            onChange={handleSelectAll}
                            disabled={page.list.length === 0}
                          />
                        </th>
                        {columns.map((col, index) => (
                          <th key={index}>{col.label}</th>
                        ))}
                      </tr>
                      </thead>
                      <tbody>
                      {page.list.length === 0 ? (
                        <tr>
                          <td
                            colSpan={columns.length + 1}
                            className="text-center text-muted"
                          >
                            Não há dados
                          </td>
                        </tr>
                      ) : (
                        page.list.map((row, idx) => (
                          <tr key={idx}>
                            <td style={{ textAlign: "center" }}>
                              <Form.Check
                                type="checkbox"
                                checked={isRowSelected(row)}
                                onChange={(e) => handleSelectRow(row, e.target.checked)}
                              />
                            </td>
                            {columns.map((col, colIdx) => (
                              <td key={colIdx}>
                                {col.render
                                  ? col.render(row)
                                  : row[col.prop]}
                              </td>
                            ))}
                          </tr>
                        ))
                      )}
                      </tbody>
                    </Table>
                  </div>
                ) : (
                  <Table className="mobile-table el-table">
                    <tbody>
                    {page.list.map((row, idx) => (
                      <React.Fragment key={idx}>
                        <tr>
                          <th>Selecionar</th>
                          <td>
                            <div className="cell">
                              <Form.Check
                                type="checkbox"
                                checked={isRowSelected(row)}
                                onChange={(e) => handleSelectRow(row, e.target.checked)}
                              />
                            </div>
                          </td>
                        </tr>
                        {columns.map((col, index) => (
                          <tr key={index}>
                            <th>{col.label}</th>
                            <td>
                              {col.render ? (
                                <div className="cell">{col.render(row)}</div>
                              ) : (
                                <div className="cell">{row[col.prop]}</div>
                              )}
                            </td>
                          </tr>
                        ))}
                        <tr>
                          <td colSpan={2}>&nbsp;</td>
                        </tr>
                      </React.Fragment>
                    ))}
                    </tbody>
                  </Table>
                )}

                <br />

                {/* Paginador */}
                <Row className="dinamic-filter-paginator align-items-center">
                  <Col xs={12} sm={8} md={4} className="mb-2 mb-md-0">
                    <Form.Group
                      controlId="limitSelect"
                      className="d-flex align-items-center mb-0"
                    >
                      <Form.Label className="mb-0 mr-2 text-nowrap">
                        Registros por página:
                      </Form.Label>
                      <Form.Control
                        as="select"
                        size="sm"
                        value={page.limit}
                        style={{ width: "80px" }}
                        onChange={(e) =>
                          refresh({ limit: Number(e.target.value) })
                        }
                      >
                        {[20, 50, 100, 200, 500, 1000].map((el) => (
                          <option key={el} value={el}>
                            {el}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Col>

                  <Col xs={12} sm={6} md={3} className="mb-2 mb-md-0">
                    <Form.Group
                      controlId="pageInput"
                      className="d-flex align-items-center mb-0"
                    >
                      <Form.Label className="mb-0 mr-2">Página:</Form.Label>
                      <Form.Control
                        size="sm"
                        type="number"
                        value={page.page}
                        style={{ width: "80px" }}
                        onChange={(e) =>
                          refresh({ page: Number(e.target.value) })
                        }
                      />
                    </Form.Group>
                  </Col>

                  <Col xs={12} sm={10} md={6} className="mb-2 mb-md-0">
                    <ButtonGroup size="sm">
                      <Button
                        variant="primary"
                        disabled={page.page <= 1}
                        onClick={() => refresh({ page: 1 })}
                        title="Primeira página"
                      >
                        «
                      </Button>
                      <Button
                        variant="primary"
                        disabled={page.page <= 1}
                        onClick={() => refresh({ page: page.page - 1 })}
                        title="Página anterior"
                      >
                        ‹
                      </Button>
                      <Button
                        variant="primary"
                        disabled={page.page >= page.totalPages}
                        onClick={() => refresh({ page: page.page + 1 })}
                        title="Próxima página"
                      >
                        ›
                      </Button>
                      <Button
                        variant="primary"
                        disabled={page.page >= page.totalPages}
                        onClick={() => refresh({ page: page.totalPages })}
                        title="Última página"
                      >
                        »
                      </Button>
                      <Button variant="primary" onClick={() => refresh()}>
                        Atualizar
                      </Button>
                    </ButtonGroup>
                  </Col>

                  <Col
                    xs={12}
                    sm={24}
                    md={11}
                    className="text-md-right text-sm-left"
                  >
                    <small className="text-muted">
                      Exibindo {page.offset + 1} -{" "}
                      {page.limit > page.totalRecords
                        ? page.totalRecords
                        : page.offset + page.limit}{" "}
                      de {page.totalRecords} registro(s)
                      {selectedRows.length > 0 && (
                        <> | <strong>{selectedRows.length}</strong> selecionado(s)</>
                      )}
                    </small>
                  </Col>
                </Row>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
  );
}

export default React.forwardRef(DataTableDinamicFilter);
